<template>
  <Animation :duration="300" leave="fadeOut">
    <div v-show="bannerOpen" class="cookies-banner__wrapper">
      <div class="cookies-banner">
        <div>
          <div class="cookies-banner__title">Información sobre cookies</div>
          <div class="cookies-banner__body">
            Utilizamos cookies propias y de terceros para fines analíticos y
            para mostrarte publicidad personalizada en base a un perfil
            elaborado a partir de tus hábitos de navegación (por ejemplo,
            páginas visitadas). Puedes aceptar todas las cookies pulsando el
            botón “Aceptar” o configurarlas o rechazar su uso pulsando el botón
            “Configurar”.
            <a target="_blank" href="/legal/politica-de-cookies"
              >Más información</a
            >
          </div>
        </div>
        <div class="cookies-banner__buttons">
          <Button @click.native="accept">Aceptar</Button>
          <Button btn-style="secondary" @click.native="openManager"
            >Configurar</Button
          >
          <Button btn-style="ghost" @click.native="reject">Rechazar</Button>
        </div>
      </div>
    </div>
  </Animation>
</template>

<script>
import Button from '@/lego/components/buttons/Button.vue';
import CookiesBus from '@/lego/utils/bus/cookies';
import {
  shouldOpenBanner,
  rejectLegalCookies,
  acceptAllLegalCookies,
} from '@/lego/utils/navigator/cookies';
import { onMounted, ref } from '@vue/composition-api';
import Animation from '@/lego/components/tools/Animation.vue';

export default {
  components: { Button, Animation },

  setup() {
    const bannerOpen = ref(false);

    CookiesBus.on('banner.open', () => {
      bannerOpen.value = true;
    });

    CookiesBus.on('banner.close', () => {
      bannerOpen.value = false;
    });

    function openManager() {
      CookiesBus.emit('manager.open');
    }

    function accept() {
      acceptAllLegalCookies();

      CookiesBus.emit('manager.close');
      CookiesBus.emit('banner.close');
    }

    function reject() {
      rejectLegalCookies();

      CookiesBus.emit('manager.close');
      CookiesBus.emit('banner.close');
    }

    onMounted(() => {
      bannerOpen.value = shouldOpenBanner();
    });

    return { bannerOpen, openManager, rejectLegalCookies, accept, reject };
  },
};
</script>

<style scoped lang="postcss">
@keyframes slideUp {
  to {
    @apply translate-y-0;
  }
}

.slide-up-animation-delayed {
  @apply translate-y-[100%];
  /**
    * Espera a que la web renderice
    * el primer contenido WOW.
    *
    * Mantiene el último estado
    * de la animación.
    */
  @apply animate-[slideUp_250ms_cubic-bezier(0.4,0.0,0.2,1)_1500ms_1_forwards];
}

.cookies-banner {
  @apply max-w-md md:max-w-xl xl:max-w-[1100px] mx-auto p-[30px_20px_16px_30px] xl:p-[40px_30px_40px_138px];
  @apply rounded-[16px] text-[#4B5563] bg-[#F9EDC4] text-[16px] box-border;
  @apply flex flex-col xl:flex-row justify-between gap-xxxs shadow-[0px_0px_7px_3px_#00000017];

  &__wrapper {
    @apply fixed z-10 box-border bottom-0 left-0 right-0 sm:right-auto p-xxs;
  }

  a {
    @apply underline;

    &:hover {
      @apply no-underline;
    }
  }

  &__title {
    @apply font-highlight text-[#1F2F4B] font-bold text-md mb-micro;
  }

  &__buttons {
    @apply flex flex-col gap-[16px] md:flex-row-reverse md:gap-[24px] xl:items-end;
  }
}
</style>
